import { createSlice } from "@reduxjs/toolkit";
import {
  activateDeactivateCategories,
  activateDeactivateRoles,
  createCategory,
  createRole,
  deleteCategory,
  deleteRole,
  fetchAllCategories,
  fetchAllPages,
  fetchAllRoles,
  fetchCategoryTableColumnNames,
  fetchPageTableColumnNames,
  fetchParentCategories,
  fetchRoleTableColumnNames,
  getDocumentsType,
  updateCategories,
  updatePagePermission,
  updateRoles,
} from "./thunk";

const categorySlice = createSlice({
  name: "categories",
  initialState: {
    categories: [],
    documentsType: [],
    parentCategories: [],
    tableColumnNames: [],
    loading: false,
    categoriesLoading: false,
    documentsTypeLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Category Table Column Names API
      .addCase(fetchCategoryTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCategoryTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchCategoryTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All CVategories API
      .addCase(fetchAllCategories.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllCategories.fulfilled, (state, action) => {
        state.loading = false;
        state.categories = action.payload;
      })
      .addCase(fetchAllCategories.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Category API
      .addCase(createCategory.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(createCategory.fulfilled, (state, action) => {
        // state.loading = false;
        state.categories = [action.payload.data[0], ...state.categories];
      })
      
      .addCase(createCategory.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Update Category API
      .addCase(updateCategories.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      // .addCase(updateCategories.fulfilled, (state, action) => {
      //   // state.loading = false;
      //   console.log("Update Category Response:", action.payload);
      //   const index = state.categories.findIndex(
      //     (item) => item.ID === action.payload[0].ID
      //   );

      //   if (index !== -1) {
      //     state.categories[index] = action.payload[0];
      //   }
      // })
      .addCase(updateCategories.fulfilled, (state, action) => {
        const updatedCategory = action.payload[0];
        const index = state.categories.findIndex(
          (item) => item.ID === updatedCategory.ID
        );

        if (index !== -1) {
          // Update the category itself
          state.categories[index] = updatedCategory;

          // If the updated category is a parent, update all its subcategories' parent name
          if (updatedCategory.IsParentCategory) {
            
            state.categories = state.categories.map(cat => {
              if (cat.ParentCategoryID == updatedCategory.ID) {
                
                return {
                  ...cat,
                  ParentCategoryNameEn: updatedCategory.ParentCategoryNameEn,
                  ParentCategoryNameAr: updatedCategory.ParentCategoryNameAr
                };
              }
              return cat;
            });
          }
        }
      })

      .addCase(updateCategories.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Delete Category API
      .addCase(deleteCategory.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(deleteCategory.fulfilled, (state, action) => {
        // state.loading = false;
        // Extract IDs from the payload
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.categories = state.categories.filter(
          (item) => !deletedIds.includes(item.ID)
        );

        // toast.success("Deleted successfully");
      })
      .addCase(deleteCategory.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })

      // Active Deactive categories
      .addCase(activateDeactivateCategories.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(activateDeactivateCategories.fulfilled, (state, action) => {
        // state.loading = false;

        if (action.payload) {
          // Ensure payload exists
          const updatedCategory = action.payload; // API returns only the updated category

          const index = state.categories.findIndex(
            (item) => item.ID === updatedCategory.ID
          );

          if (index !== -1) {
            state.categories[index] = {
              ...state.categories[index],
              IsActive: updatedCategory.IsActive,
            };
          }
        }
      })
      .addCase(activateDeactivateCategories.rejected, (state, action) => {
        // state.loading = false;
        state.error = action.payload;
      })  

      // Fetch Parent Categories API
      .addCase(fetchParentCategories.pending, (state) => {
        state.categoriesLoading = true;
        state.error = null;
      })
      .addCase(fetchParentCategories.fulfilled, (state, action) => {
        state.categoriesLoading = false;
        state.parentCategories = action.payload;
      })
      .addCase(fetchParentCategories.rejected, (state, action) => {
        state.categoriesLoading = false;
        state.error = action.payload;
      })

      // Fetch Parent Categories API
      .addCase(getDocumentsType.pending, (state) => {
        state.documentsTypeLoading = true;
        state.error = null;
      })
      .addCase(getDocumentsType.fulfilled, (state, action) => {
        state.documentsTypeLoading = false;
        state.documentsType = action.payload;
      })
      .addCase(getDocumentsType.rejected, (state, action) => {
        state.documentsTypeLoading = false;
        state.error = action.payload;
      })
  },
});

export default categorySlice.reducer;
